import { Component, OnInit } from '@angular/core';
import { UserService } from '../service/user.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-user-view',
  templateUrl: './user-view.component.html',
  styleUrls: ['./user-view.component.css']
})
export class UserViewComponent implements OnInit {

  constructor(private userService: UserService) {
  }

  user_obs!: Observable<any>

  ngOnInit(): void {
    this.getUserInfo();
  }

  getUserInfo() {
    this.user_obs = this.userService.getMyInfo();
    const _user_sub = this.user_obs.subscribe(
    );
  }

}
